
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const UserRole = {
  ADMIN: 'ADMIN',
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
  AFFILIATE: 'AFFILIATE'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const PaymentMethod = {
  EASYPAISA: 'EASYPAISA',
  JAZZCASH: 'JAZZCASH',
  BANK_TRANSFER: 'BANK_TRANSFER'
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]


export const PaymentStatus = {
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
} as const

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus]


export const EnrollmentStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED'
} as const

export type EnrollmentStatus = (typeof EnrollmentStatus)[keyof typeof EnrollmentStatus]


export const PayoutStatus = {
  PAID: 'PAID',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
} as const

export type PayoutStatus = (typeof PayoutStatus)[keyof typeof PayoutStatus]


export const FeedbackCategory = {
  QUESTION: 'QUESTION',
  PROBLEM: 'PROBLEM',
  SUGGESTION: 'SUGGESTION',
  OTHER: 'OTHER'
} as const

export type FeedbackCategory = (typeof FeedbackCategory)[keyof typeof FeedbackCategory]


export const FeedbackStatus = {
  RESOLVED: 'RESOLVED',
  PENDING: 'PENDING'
} as const

export type FeedbackStatus = (typeof FeedbackStatus)[keyof typeof FeedbackStatus]


export const ReactionType = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE'
} as const

export type ReactionType = (typeof ReactionType)[keyof typeof ReactionType]


export const NotificationStatus = {
  READ: 'READ',
  UNREAD: 'UNREAD'
} as const

export type NotificationStatus = (typeof NotificationStatus)[keyof typeof NotificationStatus]


export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
} as const

export type Gender = (typeof Gender)[keyof typeof Gender]
